import { Loader2 } from 'lucide-react';

const Loader = () => {
  return (
    <div className="flex flex-1 items-center justify-center">
      <Loader2 className="size-8 animate-spin" />
    </div>
  );
};

export default Loader;
